{
  "skins": [
    {
      "skin": "#f0d5c2",
      "skin-shade": "#cfa58b",
      "skin-highlight": "#f8e4d5",
      "feature": "#211e1c",
      "lip": "#ae7b71",
      "mouth-line": "#674a43",
      "iris": "#707b75"
    },
    {
      "skin": "#e5bc9f",
      "skin-shade": "#bc896c",
      "skin-highlight": "#f3d3bb",
      "feature": "#211e1c",
      "lip": "#ab7668",
      "mouth-line": "#66453c",
      "iris": "#514333"
    },
    {
      "skin": "#d4a07d",
      "skin-shade": "#a57051",
      "skin-highlight": "#e7bd9b",
      "feature": "#211e1c",
      "lip": "#ab7668",
      "mouth-line": "#66453c",
      "iris": "#514333"
    },
    {
      "skin": "#bc8865",
      "skin-shade": "#8f6045",
      "skin-highlight": "#d5aa87",
      "feature": "#211e1c",
      "lip": "#a56a5e",
      "mouth-line": "#604035",
      "iris": "#514333"
    },
    {
      "skin": "#a47554",
      "skin-shade": "#764d39",
      "skin-highlight": "#bf9372",
      "feature": "#211e1c",
      "lip": "#a56a5e",
      "mouth-line": "#604035",
      "iris": "#514333"
    },
    {
      "skin": "#825a42",
      "skin-shade": "#5e3f30",
      "skin-highlight": "#a87f60",
      "feature": "#211e1c",
      "lip": "#a7796c",
      "mouth-line": "#d3a28e",
      "iris": "#514333"
    },
    {
      "skin": "#614334",
      "skin-shade": "#422c24",
      "skin-highlight": "#956d53",
      "feature": "#211e1c",
      "lip": "#9e7667",
      "mouth-line": "#d6aa93",
      "iris": "#514333"
    }
  ],
  "hair": {
    "black": {
      "hair": "#282725",
      "hair-shade": "#847269"
    },
    "dark-brown": {
      "hair": "#3b302c",
      "hair-shade": "#847269"
    },
    "brown": {
      "hair": "#645045",
      "hair-shade": "#847269"
    },
    "auburn": {
      "hair": "#855448",
      "hair-shade": "#847269"
    },
    "blonde": {
      "hair": "#b9a078",
      "hair-shade": "#847269"
    },
    "grey": {
      "hair": "#8d908c",
      "hair-shade": "#aca99a"
    },
    "silver": {
      "hair": "#c8ccc8",
      "hair-shade": "#aca99a"
    },
    "salt-and-pepper": {
      "hair": "#737871",
      "hair-shade": "#aca99a"
    }
  },
  "layerOrder": [
    "backdrop",
    "hair-back",
    "neck",
    "clothing",
    "ears",
    "head",
    "age-lines",
    "under-eye",
    "brows-neutral",
    "brows-pleased",
    "brows-concerned",
    "brows-tired",
    "brows-irritated",
    "brows-upset",
    "brows-guarded",
    "eyes-neutral",
    "eyes-pleased",
    "eyes-concerned",
    "eyes-tired",
    "eyes-irritated",
    "eyes-upset",
    "eyes-guarded",
    "mouth-neutral",
    "mouth-pleased",
    "mouth-concerned",
    "mouth-tired",
    "mouth-irritated",
    "mouth-upset",
    "mouth-guarded",
    "facial-hair",
    "glasses",
    "hair-front"
  ],
  "source": "0.2-layered-vector"
}
